import userProfileDefault from "@/assets/image/user-profile3.png";
import AddPhotoIcon from "@/assets/SVG/addPhotoIcon";
import DeleteIcon from "@/assets/SVG/deleteIcon";
import { Box, Grid, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { useState } from "react";

function GroupPic() {
  const [hover, setHover] = useState(true);
  const { values, setValues } = useFormikContext();

  const onChangeValueImage = (event) => {
    const file = event.target.files[0];
    let url = window?.URL?.createObjectURL(file);

    setValues((prevValues) => ({
      ...prevValues,
      ...{ image: { file: file, url: url } },
    }));
  };

  return (
    <>
      <Grid
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={"10px"}
        width={"100%"}
      >
        <Box width="120px" height="120px" mt="25px" position="relative">
          <img
            style={{
              width: "120px",
              height: "120px",
              borderRadius: "50%",
              position: "absolute",
            }}
            onMouseEnter={() => {
              setHover(true);
            }}
            className="imageHover"
            src={values?.image?.url || userProfileDefault}
          />
          {hover && (
            <>
              <label
                htmlFor="upload-image"
                style={{
                  cursor: "pointer",
                  position: "relative",
                  display: "inline-block",
                }}
              >
                <input
                  id="upload-image"
                  onChange={onChangeValueImage}
                  hidden
                  accept={"image/gif,.jpg,.png,.WebP,.JPEG"}
                  multiple
                  type="file"
                />

                <Box
                  onMouseLeave={() => setHover(false)}
                  width="120px"
                  height="120px"
                  borderRadius="50%"
                  bgcolor="#00000090"
                  display="grid"
                  justifyItems="center"
                  alignContent="center"
                  sx={{ cursor: "pointer" }}
                >
                  <AddPhotoIcon />
                  <Typography color="white" mt="10px">
                    {"ویرایش عکس"}
                  </Typography>
                </Box>
              </label>
            </>
          )}
        </Box>
        {values.image && (
          <Box
            mt="10px"
            sx={{ cursor: "pointer" }}
            display="flex"
            alignItems="center"
            alignContent={"center"}
            onClick={() => {
              setValues((prevValues) => ({
                ...prevValues,
                image: undefined,
              }));
            }}
          >
            <DeleteIcon />
            <Typography mr="5px" fontSize="11px" color="var(--emr-red)">
              {"حذف عکس"}
            </Typography>
          </Box>
        )}
      </Grid>
    </>
  );
}

export default GroupPic;
